import React, { useState } from "react";
import Select, { components } from "react-select";
import Checkbox from "../../atoms/checkbox";
import styled from "styled-components";
import ProductInformationCache from "../../persistence/description-cache";

const SELECT_OPTION = 'select-option';
const DESELECT_OPTION = 'deselect-option';
const REMOVE_VALUE = 'remove-value';
const CLEAR = 'clear';
const POP_VALUE = 'pop-value';

const Wrapper = styled.div`
  margin-right: 10px;
  @media (max-width: 800px) {
    margin-right: 0px;
  }
`;

const DropdownRow = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-left: 5px;
  overflow: hidden;
`;

const DropdownText = styled.span`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = "transparent";
  if (isFocused) bg = "#eee";
  if (isActive) bg = "#B2D4FF";

  const style = {
    alignItems: "center",
    backgroundColor: bg,
    color: "inherit",
    display: "flex ",
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style,
  };

  const description = ProductInformationCache.getDescription(children);

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <Checkbox checked={isSelected}></Checkbox>
      <DropdownRow>
        <DropdownText>{children}</DropdownText>
        <DropdownText title={description}>{description}</DropdownText>
      </DropdownRow>
    </components.Option>
  );
};

class LicenceSelectorUpdateList extends React.Component {

  buildOptions = (answer) => {
    return (answer?.updateMapping || [])
      .map((correspondance) => {
        return {value: correspondance.correspondanceId, "label": correspondance.previousLicence};
      });
  }

  buildDefaultValue = (answer, userAnswers) => {
    return (answer?.updateMapping || [])
      .filter((correspondance) => {
        return userAnswers[correspondance.correspondanceId] != null;
      })
      .map((correspondance) => {
        return {value: correspondance.correspondanceId, "label": correspondance.previousLicence};
      });
  }

  render = () => {
    const { answer, userAnswers, setAnswer } = this.props;

    return (
      <Wrapper>
        <Select
          defaultValue={this.buildDefaultValue(answer, userAnswers)}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          onChange={(options, actionProps) => {
            if (actionProps.action === SELECT_OPTION) {
              setAnswer(actionProps.option.value, 1);
            } else if (actionProps.action === DESELECT_OPTION) {
              setAnswer(actionProps.option.value, null);
            } else if (actionProps.action === REMOVE_VALUE) {
              setAnswer(actionProps.removedValue.value, null);
            } else if (actionProps.action === CLEAR) {
              this.props.clearAnswers((actionProps.removedValues || []).map(val => val.value));
            } else if (actionProps.action === POP_VALUE) {
              setAnswer(actionProps.removedValue.value, null);
            }
          }}
          options={this.buildOptions(answer)}
          components={{
            Option: InputOption,
          }}
        />
      </Wrapper>
    );
  };
}

export default LicenceSelectorUpdateList;
